import Box from '@mui/material/Box';
import React from 'react';
import { Outlet } from 'react-router';

const LoginLayout = () => (
  <Box sx={{ flexGrow: 1, position: 'relative', display: 'flex', flexDirection: 'column' }}>
    <Outlet />
  </Box>
);

export default LoginLayout;
